import config, { getCurrentLanguage } from "settings/languageConfig";

import languageAction from "./actions";

const initState = {
  isActivated: false,
  language: getCurrentLanguage(config.defaultLanguage || "english")
  // language: "english"
};

export default function (state = initState, action) {
  switch (action.type) {
    case languageAction.ACTIVATE_LANG_MODAL:
      return {
        ...state,
        isActivated: !state.isActivated
      };
    case languageAction.CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.language
      };
    default:
      return state;
  }
}
